(function () {
    'use strict';

    function dashboardRoutes($stateProvider) {

        $stateProvider
            .state('findpartners', {
                url: '/entities/find/partners/:index',
                controller: 'directPartnerConnectionEditorController',
                controllerAs: 'search',
                templateUrl: 'dashboards/templates/directPartnerConnectionEditor.html',
                resolve: {
                    searchConfiguration: [
                        "$stateParams", "searchConfigurationDataService", function($stateParams, searchConfigurationDataService) {
                            return searchConfigurationDataService.loadEntitiesSearch($stateParams.index).then(function(data) {
                                return data;
                            });
                        }
                    ],
                    sessionData: [
                        "sessionDataService", function(sessionDataService) {
                            return sessionDataService.loadSession().then(function(data) {
                                return data;
                            });
                        }
                    ],
                    milestones: function () {
                        return ['FindPartners'];
                    }
                }
            })
            .state('applyforprojects', {
                url: '/entities/find/projects',
                controller: 'applyForProjectsController',
                controllerAs: 'applyForProjectsCtrl',
                templateUrl: 'dashboards/templates/applyForProjects.html',
                resolve: {
                    sessionData: [
                        "sessionDataService", function(sessionDataService) {
                            return sessionDataService.loadSession().then(function(data) {
                                return data;
                            });
                        }
                    ],
                    milestones: function() {
                        return ['ProjectOpportunities'];
                    }
                }
            })
            .state('findentities', {
                url: '/search/entities/:index',
                controller: 'searchController',
                controllerAs: 'search',
                templateUrl: 'dashboards/templates/search.html',
                resolve: {
                    searchConfiguration: [
                        "$stateParams", "searchConfigurationDataService", function($stateParams, searchConfigurationDataService) {
                            return searchConfigurationDataService.loadEntitiesSearch($stateParams.index).then(function(data) {
                                return data;
                            });
                        }
                    ],
                    sessionData: [
                        "sessionDataService", function(sessionDataService) {
                            return sessionDataService.loadSession().then(function(data) {
                                return data;
                            });
                        }
                    ]
                }
            })
            .state('entitydashboardhome', {
                url: '/entities/home/index',
                controller: 'entityDashboardController',
                controllerAs: 'dashboardCtrl',
                templateUrl: 'dashboards/templates/entityDashboard.html',
                resolve: {
                    sessionData: [
                        "sessionDataService", function(sessionDataService) {
                            return sessionDataService.loadSession().then(function(data) {
                                return data;
                            });
                        }
                    ],
                    myProfile: [
                        "myProfileDataService", function(myProfileDataService) {
                            return myProfileDataService.loadMyProfile().then(function(data) {
                                data.Attributes.forEach(function(attribute) {
                                    attribute.Mode = 'Editor';
                                });
                                return data;
                            });
                        }
                    ],
                    milestones: function () {
                        return ['Dashboard'];
                    }
                }
            })
            .state('entitydashboardmyprofile', {
                url: '/entities/home/index/myprofile',
                controller: 'entityDashboardController',
                controllerAs: 'dashboardCtrl',
                templateUrl: 'dashboards/templates/entityDashboard.html',
                resolve: {
                    sessionData: [
                        "sessionDataService", function(sessionDataService) {
                            return sessionDataService.loadSession().then(function(data) {
                                return data;
                            });
                        }
                    ],
                    myProfile: [
                        "myProfileDataService", function(myProfileDataService) {
                            return myProfileDataService.loadMyProfile().then(function(data) {
                                data.Attributes.forEach(function(attribute) {
                                    attribute.Mode = 'Editor';
                                });
                                return data;
                            });
                        }
                    ],
                    milestones: function() {
                        return ['Dashboard'];
                    }
                }
            })
            .state('dashboard', {
                url: '/dashboard',
                controller: 'entityDashboardController',
                controllerAs: 'dashboardCtrl',
                templateUrl: 'dashboards/templates/entityDashboard.html',
                resolve: {
                    sessionData: [
                        "sessionDataService", function(sessionDataService) {
                            return sessionDataService.loadSession().then(function(data) {
                                return data;
                            });
                        }
                    ],
                    myProfile: [
                        "myProfileDataService", function(myProfileDataService) {
                            return myProfileDataService.loadMyProfile().then(function(data) {
                                data.Attributes.forEach(function(attribute) {
                                    attribute.Mode = 'Editor';
                                });
                                return data;
                            });
                        }
                    ],
                    dashboardFeatures: [
                        "dashboardFeaturesDataService", function(dashboardFeaturesDataService) {
                            return dashboardFeaturesDataService.loadDashboardFeatures().then(function(data) {
                                return data;
                            });
                        }
                    ],
                    dashboardActivities: [
                        "sessionData", "dashboardActivityOptionsDataService", function (sessionData, dashboardActivityOptionsDataService) {
                            if (sessionData.Entity && sessionData.Entity.PlatformEntityId) {
                                return dashboardActivityOptionsDataService.getDashboardActivityOptionsForEntity(
                                    sessionData.Entity.PlatformEntityId.toLowerCase()
                               ).then(function (data) {
                                   return data;
                               });
                            }
                            else {
                                return dashboardActivityOptionsDataService.getDashboardActivityOptions().then(function (data) {
                                    return data;
                                });
                            }
                        }
                    ],
                    mostRecentItems: [
                        "mostRecentItemsDataService", function (mostRecentItemsDataService) {
                            return mostRecentItemsDataService.getMostRecentItems().then(function (data) {
                                return data;
                            });
                        }
                    ],
                    mostRecentItemsThumbnails: [
                        "mostRecentItems", "thumbnailsDataService", function (mostRecentItems, thumbnailsDataService) {
                            var workflowIds = mostRecentItems.map(function (item) {
                                return item.WorkflowId
                            });

                            return thumbnailsDataService.loadThumbnailsForWorkflows(workflowIds).then(function (data) {
                                return data
                            });
                        }
                    ],
                    milestones: function () {
                        return ['Dashboard'];
                   }
                }
            })
            .state('editmyprofile', {
                url: '/myprofile',
                controller: 'editMyProfileController',
                controllerAs: 'editMyProfileCtrl',
                templateUrl: 'dashboards/templates/editMyProfile.html',
                resolve: {
                    sessionData: [
                        "sessionDataService", function(sessionDataService) {
                            return sessionDataService.loadSession().then(function(data) {
                                return data;
                            });
                        }
                    ],
                    profile: [
                        "myProfileDataService", "$stateParams", function(myProfileDataService, $stateParams) {
                            return myProfileDataService.loadMyProfile().then(function(data) {
                                data.Attributes.forEach(function(attribute) {
                                    attribute.Mode = 'Editor';
                                });
                                data.AdminAttributes.forEach(function(attribute) {
                                    attribute.Mode = 'Editor';
                                });
                                return data;
                            });
                        }
                    ]
                }
            })
            .state('resources', {
                url: '/resources',
            })
            .state('comments', {
                url: '/comments',
                controller: 'commentsController',
                controllerAs: 'commentsCtrl',
                templateUrl: 'dashboards/templates/comments.html',
                resolve: {
                    sessionData: [
                        "sessionDataService", function(sessionDataService) {
                            return sessionDataService.loadSession().then(function(data) {
                                return data;
                            });
                        }
                    ],
                    newNotesData: [
                        "underwritingNotesDataService", function (underwritingNotesDataService) {
                            return underwritingNotesDataService.getNewNotes().then(function (data) {
                                return data;
                            });
                        }
                    ],
                    thumbnailsData: [
                        "newNotesData", "thumbnailsDataService",
                        function (newNotesData, thumbnailsDataService) {
                            var workflowsAndPaths = [];
                            newNotesData.forEach(function (note) {
                                workflowsAndPaths.push({
                                    WorkflowId: note.Note.ObjectId,
                                    Path: note.Note.Path
                                });
                            });

                            return thumbnailsDataService.loadThumbnailsForWorkflowsAndPaths(workflowsAndPaths)
                                .then(function (data) {
                                    return data
                                });
                        }
                    ]
                }
            })
            .state('entityactivities', {
                url: '/entities/home/activities',
                controller: 'entityActivitiesController',
                controllerAs: 'activitiesCtrl',
                templateUrl: 'dashboards/templates/entityActivities.html',
                resolve: {
                    milestonesAndProfile: [
                        "myProfileDataService", function(myProfileDataService) {
                            return myProfileDataService.loadMyProfile().then(function(data) {
                                data.Attributes.forEach(function(attribute) {
                                    attribute.Mode = 'Editor';
                                });

                                var milestoneNames = ['Activities'];
                                if (data.ReferralCampaign && data.ReferralCampaign.length > 0) {
                                    milestoneNames.push("ReferralCampaign");
                                }

                                return {
                                    profile: data,
                                    milestones: milestoneNames
                                }
                            });
                        }
                    ]
                }
            });
    }

    dashboardRoutes.$inject = ['$stateProvider'];

    angular.module('ecap.dashboards').config(dashboardRoutes);
})();